import { borderRadius, colors, fontSizes, fontWeights } from '@/theme'
import { Chip } from '@mui/material'
import IDVerifiedIcon from './icons/IDVerifiedIcon'

interface IDVerifiedChipProps {
  verified?: boolean
}

export default function IDVerifiedChip({ verified = true }: IDVerifiedChipProps) {
  if (verified) {
    return (
      <Chip
        icon={<IDVerifiedIcon />}
        label='ID Verified'
        size='small'
        sx={{
          px: 1,
          py: 0.5,
          height: '24px',
          bgcolor: colors.status.successLight,
          color: colors.status.success,
          border: `1px solid ${colors.status.success}`,
          borderRadius: borderRadius.lg,
          fontSize: fontSizes.sm,
          fontWeight: fontWeights.bold,
          '& .MuiChip-label': {
            p: 0,
            ml: 0.5
          },
          '& .MuiChip-icon': {
            ml: 0,
            mr: 0
          }
        }}
      />
    )
  }

  return (
    <Chip
      label='ID not verified'
      size='small'
      sx={{
        px: 1,
        py: 0.5,
        height: '24px',
        bgcolor: colors.grey[100],
        color: colors.grey[500],
        border: `1px solid ${colors.grey[300]}`,
        borderRadius: borderRadius.lg,
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.bold,
        '& .MuiChip-label': {
          p: 0,
          ml: 0.5
        }
      }}
    />
  )
}
